const home = [
    {
        path: '/home',
        name: 'home',
        component: () => import('../views/home/index.vue')
    }
]

export default home